import GoogleMapPreview from "components/app/google-map/GoogleMapPreview";
import { Separator } from "components/ui/separator";
import { Copy, Heart, House, Info, MapPin } from "lucide-react";
import moment from "moment";
import { Link } from "react-router-dom";
import useClipboard from "react-use-clipboard";

interface PropsType {
  user: any;
}

export default function ProfileInfoContent({ user }: PropsType) {
  const linkUrlClipboard = `${process.env.REACT_APP_URL}/profile?id=
    ${user?.id}`;
  const [isCopied, setCopied] = useClipboard(linkUrlClipboard, {
    successDuration: 1000,
  });
  return (
    <div className="flex justify-center">
      <div className="w-[750px] min-h-[1000px] bg-background rounded-lg p-4">
        {user?.professional ? (
          <div className="mb-3">
            <p className="text-lg font-bold">Professional</p>
            <div className="flex items-center space-x-3 p-1 mb-3">
              <Info />
              <p className="text-sm font-semibold">{user?.professional}</p>
            </div>
            <Separator />
          </div>
        ) : (
          <></>
        )}

        {user?.birth_address ? (
          <div className="mb-3">
            <p className="text-lg font-bold">Birth Address</p>
            <div className="flex items-center space-x-3 p-1 mb-3">
              <House />
              <p className="text-sm font-semibold">From {user.birth_address}</p>
            </div>
            <Separator />
          </div>
        ) : (
          <></>
        )}

        {user?.current_address ? (
          <div className="mb-3">
            <p className="text-lg font-bold">Current Address</p>
            <div className="flex items-center space-x-3 p-1 mb-3">
              <MapPin />
              <p className="text-sm font-semibold">From {user?.current_address}</p>
            </div>
            <Separator />
          </div>
        ) : (
          <></>
        )}

        {user?.marital_status ? (
          <div className="mb-3">
            <p className="text-lg font-bold">Marital Status</p>
            <div className="flex items-center space-x-3 p-1 mb-3">
              <Heart />
              <p className="text-sm font-semibold">{user?.marital_status}</p>
            </div>
            <Separator />
          </div>
        ) : (
          <></>
        )}

        {user?.facebook_link ? (
          <div className="mb-3">
            <p className="text-lg font-bold">Facebook</p>
            <div className="flex items-center space-x-3 p-1 mb-3">
              <i className="fa-brands fa-facebook fa-lg" />
              <Link to={user?.facebook_link} className="text-sm font-semibold">
                {user?.facebook_link}
              </Link>
            </div>
            <Separator />
          </div>
        ) : (
          <></>
        )}

        {user?.telegram_link ? (
          <div className="mb-3">
            <p className="text-lg font-bold">Telegram</p>
            <div className="flex items-center space-x-3 p-1 mb-3">
              <i className="fa-brands fa-telegram fa-lg" />
              <Link to={user?.telegram_link} className="text-sm font-semibold">
                {user?.telegram_link}
              </Link>
            </div>
            <Separator />
          </div>
        ) : (
          <></>
        )}

        {user?.youtube_link ? (
          <div className="mb-3">
            <p className="text-lg font-bold">Youtube</p>
            <div className="flex items-center space-x-3 p-1 mb-3">
              <i className="fa-brands fa-youtube fa-lg" />
              <Link to={user?.youtube_link} className="text-sm font-semibold">
                {user?.youtube_link}
              </Link>
            </div>
            <Separator />
          </div>
        ) : (
          <></>
        )}

        {user?.tiktok_link ? (
          <div className="mb-3">
            <p className="text-lg font-bold">TikTok</p>
            <div className="flex items-center space-x-3 p-1 mb-3">
              <i className="fa-brands fa-tiktok fa-lg" />
              <Link to={user?.tiktok_link} className="text-sm font-semibold">
                {user?.tiktok_link}
              </Link>
            </div>
            <Separator />
          </div>
        ) : (
          <></>
        )}

        <div className="mb-3">
          <p className="text-lg font-bold">FlipFlop</p>
          <div className="relative flex items-center space-x-3 p-1 mb-3">
            <div className="cursor-pointer" onClick={setCopied}>
              <Copy />
            </div>
            {isCopied && <span className="absolute top-7 -left-4 text-green-500 text-xs">Copied!</span>}

            <p onClick={setCopied} className="text-sm font-semibold cursor-pointer">
              {process.env.REACT_APP_URL}/profile?id={user?.id}
            </p>
          </div>
          <Separator />
        </div>

        <div className="mb-3">
          <p className="text-lg font-bold">Joined FlipFlop</p>
          <div className="flex items-center space-x-3 p-1 mb-3">
            <Info />
            <p className="text-sm font-semibold">Joined FlipFlop on {moment(user?.created_at).format("MMMM DD, YYYY")}</p>
          </div>
        </div>

        {user?.user_type === "Page" ? (
          <>
            {user?.current_latitude && user?.current_longitude ? (
              <div className="mb-3">
                <p className="text-lg font-bold">Google Map</p>
                <div className="h-[400px] w-full mt-2">
                  <GoogleMapPreview latitude={user?.current_latitude} longitude={user?.current_longitude} />
                </div>
              </div>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
